import request from "../router/request";
import router from '../router';

let refreshIntervalId = null; 

async function validarToken() {
    const token = localStorage.getItem('token');
    if (!token) {
        router.push('/');
        return;
    }

    try {
        await request.get('/usuario/dados', {
            headers: { Authorization: `Bearer ${token}` }
        });

    } catch (err) {
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            router.push('/');
        } else {
            console.error('Erro inesperado na validação do token:', err);
        }
    }
}

function startTokenRefreshInterval() {
    if (refreshIntervalId) {
        clearInterval(refreshIntervalId);
    }

    refreshIntervalId = setInterval(async () => {
        if (localStorage.getItem('token')) {
            try {
                const response = await request.post("/usuario/refresh", {});
                if (response.data.token) {
                    localStorage.setItem("token", response.data.token);
                    console.log('Token refreshed at:', new Date().toLocaleTimeString());
                }
            } catch (err) {
                console.error('Erro ao fazer refresh do token:', err);
            }
        }
    }, 60 * 60 * 1000); // 60 minutos
}

function stopTokenRefreshInterval() {
    if (refreshIntervalId) {
        clearInterval(refreshIntervalId);
        refreshIntervalId = null;
    }
}

export default { validarToken, startTokenRefreshInterval, stopTokenRefreshInterval };